import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx } from "vue"
import _imports_0 from '../../public/pb-logo.png'
import _imports_1 from '../../public/PoweredBy.png'


const _hoisted_1 = { class: "dx-card content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  id: "pb-login-logo",
  src: _imports_0
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  key: 2,
  class: "description"
}
const _hoisted_6 = {
  key: 0,
  class: "powered-by-login-container"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]

import DxScrollView from "devextreme-vue/scroll-view";

import { useRoute } from 'vue-router';
import { watch, ref, computed } from 'vue';
import AcquaintLogo from "@/assets/acquaint-logo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'single-card',
  setup(__props) {

const route = useRoute();

const title = ref(route.meta.title);
const description = ref("");

// Note: this is hardcoded to true for now. In the future, this will be determined based on the current url
const usePropertyButtonBranding = computed(() => window.location.host.includes('propertybutton.ie'));

watch(() => route.path,
  () => {
    title.value = route.meta.title;
    description.value = route?.meta?.description?.toString() ?? '';
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxScrollView), {
    height: "100%",
    width: "100%",
    class: "with-footer single-card"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (usePropertyButtonBranding.value)
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : (_openBlock(), _createBlock(AcquaintLogo, { key: 1 })),
          _createElementVNode("div", _hoisted_4, _toDisplayString(title.value), 1),
          (description.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(description.value), 1))
            : _createCommentVNode("", true)
        ]),
        _renderSlot(_ctx.$slots, "default"),
        (usePropertyButtonBranding.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}
}

})